import React from 'react';
import SingleColumn from 'components/ScalarSpreadsheet/components/single-column/SingleColumn';
import FastValueViewer from 'components/ScalarSpreadsheet/utilities/FastValueViewer';
import { Cell } from 'components/Spreadsheet/components';
import { TotalsColumnProps } from './TotalsColumn.props';

const TotalsColumn = ({ className = '', data }: TotalsColumnProps) => (
  <SingleColumn data={data} className={className} cellRenderer={Cell} valueViewer={FastValueViewer} />
);

export default TotalsColumn;
